/**
 * @file ContentArea/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const DISPLAY_POLICIES = {
    default: "DISPLAY_POLICY_DEFAULT",
    debug: "DISPLAY_POLICY_DEBUG",
    high: "DISPLAY_POLICY_HIGH_DENSITY",
    medium: "DISPLAY_POLICY_MED_DENSITY",
    listing: "DISPLAY_POLICY_LISTING",
    homepage: "DISPLAY_POLICY_HOMEPAGE",
    rich: "DISPLAY_POLICY_RICH",
    search: "DISPLAY_POLICY_SEARCH",
};
export const DEFAULT_MAP_KEY = "default";

export const VIEWPORT_MOBILE = "viewportSmall";

export const FEATURED_DENSE_COUNT = 16;

export const POLITICS_FEATURED_DENSE_COUNT = 20;
